import axios from 'axios';
import config from '../config';
import { OnboardDeviceHardwareConfiguration } from '../interfaces';

export const deleteOnboardDevicesHardwareConfiguration = (
    id: string,
): Promise<OnboardDeviceHardwareConfiguration> => {
    return axios
        .delete(`${config.API_URL}/onboard-devices/hardware-configurations/${id}`)
        .then((response: any) => {
            return response.data;
        });
};
